"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var WebFont = require('webfontloader');
var Rx_1 = require('rxjs/Rx');
require('rxjs/add/operator/debounceTime');
require('rxjs/add/operator/distinctUntilChanged');
var forms_1 = require('@angular/forms');
var core_1 = require('@angular/core');
var angular2_perfect_scrollbar_1 = require('angular2-perfect-scrollbar');
var font_picker_service_1 = require('./font-picker.service');
var interfaces_1 = require('./interfaces');
var FontPickerComponent = (function () {
    function FontPickerComponent(el, service) {
        this.el = el;
        this.service = service;
        this.styles = [];
        this.fontAmount = 5;
        this.loadedFonts = 0;
        this.presetFonts = [];
        this.googleFonts = [];
        this.currentFonts = [];
        this.dialogArrowSize = 10;
        this.dialogArrowOffset = 15;
        this.searchTerm = new forms_1.FormControl('');
        this.config = {
            suppressScrollX: true
        };
        this.loading = true;
        this.selectedFont = false;
        this.presetVisible = true;
    }
    FontPickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.searchTerm
            .valueChanges
            .debounceTime(500)
            .distinctUntilChanged()
            .subscribe(function (text) {
            if (!text) {
                _this.presetVisible = true;
                _this.listLabel = 'Popular fonts';
            }
            else {
                _this.presetVisible = false;
                _this.listLabel = 'Search results';
            }
            _this.searchGoogleFonts(text);
        });
        // Don't allow too many loading requests in a short time span.
        Rx_1.Observable.fromEvent(this.el.nativeElement, 'ps-y-reach-end')
            .debounceTime(150)
            .subscribe(function () { return _this.loadMoreFonts(); });
        this.testContainer = document.createElement('span');
        this.testContainer.innerHTML = Array(100).join('wi');
        this.testContainer.style.cssText = [
            'position: absolute',
            'width: auto',
            'font-size: 128px',
            'left: -99999px'
        ].join(' !important;');
        this.listenerResize = function () { return _this.onResize(); };
        this.listenerMouseDown = function (event) { return _this.onMouseDown(event); };
        this.openFontPicker();
    };
    FontPickerComponent.prototype.setDialog = function (instance, elementRef, font, fpPosition, fpPositionOffset, fpPositionRelativeToArrow, fpPresetLabel, fpPresetFonts, fpUploadButton, fpUploadButtonClass, fpUploadButtonText, fpStyleSelect, fpSizeSelect, fpCancelButton, fpCancelButtonClass, fpCancelButtonText, fpHeight, fpWidth) {
        var _this = this;
        this.listLabel = 'Loading fonts...';
        this.directiveInstance = instance;
        this.directiveElementRef = elementRef;
        this.updateDialog(font, fpPosition, fpPositionOffset, fpPositionRelativeToArrow, fpPresetLabel, fpPresetFonts, fpUploadButton, fpUploadButtonClass, fpUploadButtonText, fpStyleSelect, fpSizeSelect, fpCancelButton, fpCancelButtonClass, fpCancelButtonText, fpHeight, fpWidth);
        this.service.getAllFonts('popularity').subscribe(function (data) {
            _this.loading = false;
            _this.googleFonts = data.items.map(function (font) { return _this.convertGoogleFont(font); });
            // Find styles for initial font
            var searchFont = _this.findFont(_this.initialFont.family, true);
            if (searchFont) {
                _this.font.files = searchFont.files;
                _this.font.styles = searchFont.styles;
                _this.loadGoogleFonts([_this.font]);
            }
            // Load Open Sans if available
            var openSans = _this.googleFonts.find(function (font) { return font.family == 'Open sans'; });
            _this.loadGoogleFonts([openSans]);
        }, function (err) { return console.log(err); });
    };
    FontPickerComponent.prototype.updateDialog = function (font, fpPosition, fpPositionOffset, fpPositionRelativeToArrow, fpPresetLabel, fpPresetFonts, fpUploadButton, fpUploadButtonClass, fpUploadButtonText, fpStyleSelect, fpSizeSelect, fpCancelButton, fpCancelButtonClass, fpCancelButtonText, fpHeight, fpWidth) {
        this.font = font;
        this.styles = font.styles;
        this.initialFont = new interfaces_1.Font(font);
        this.fpPosition = fpPosition;
        this.fpPositionOffset = parseInt(fpPositionOffset);
        if (!fpPositionRelativeToArrow) {
            this.dialogArrowOffset = 0;
        }
        this.fpPresetLabel = fpPresetLabel;
        this.fpPresetFonts = fpPresetFonts;
        this.fpStyleSelect = fpStyleSelect;
        this.fpSizeSelect = fpSizeSelect;
        this.fpCancelButton = fpCancelButton;
        this.fpCancelButtonText = fpCancelButtonText;
        this.fpCancelButtonClass = fpCancelButtonClass;
        this.fpUploadButton = fpUploadButton;
        this.fpUploadButtonText = fpUploadButtonText;
        this.fpUploadButtonClass = fpUploadButtonClass;
        this.fpWidth = parseInt(fpWidth);
        this.fpHeight = parseInt(fpHeight);
        this.searchTerm.reset({ disabled: (this.fpPresetFonts.length > 0) });
        this.setDisplayedFontSource();
    };
    FontPickerComponent.prototype.openFontPicker = function () {
        if (!this.open) {
            this.setDialogPosition();
            this.searchTerm.setValue('');
            window.addEventListener('resize', this.listenerResize);
            document.addEventListener('mousedown', this.listenerMouseDown);
            this.open = true;
        }
    };
    FontPickerComponent.prototype.closeFontPicker = function () {
        this.open = false;
        window.removeEventListener('resize', this.listenerResize);
        document.removeEventListener('mousedown', this.listenerMouseDown);
    };
    FontPickerComponent.prototype.isFontAvailable = function (font) {
        if (!this.testWidth) {
            this.testContainer.style.fontFamily = 'monospace';
            document.body.appendChild(this.testContainer);
            this.testWidth = this.testContainer.clientWidth;
            document.body.removeChild(this.testContainer);
        }
        this.testContainer.style.fontFamily = font.family + ', monospace';
        document.body.appendChild(this.testContainer);
        var width = this.testContainer.clientWidth;
        document.body.removeChild(this.testContainer);
        return width != this.testWidth;
    };
    FontPickerComponent.prototype.getPresetFonts = function () {
        var _this = this;
        var presetFonts = [];
        if (this.googleFonts && this.fpPresetFonts && this.fpPresetFonts.length) {
            this.fpPresetFonts.forEach(function (font) {
                var fontClass = _this.findFont(font, true);
                if (!fontClass) {
                    fontClass = new interfaces_1.Font({
                        family: font,
                        size: null,
                        style: null,
                        styles: ['regular', 'italic']
                    });
                }
                presetFonts.push(fontClass);
            });
            this.presetFonts = presetFonts;
            return presetFonts;
        }
    };
    FontPickerComponent.prototype.setDisplayedFontSource = function () {
        if (this.fpPresetFonts && this.fpPresetFonts.length) {
            this.setCurentFonts(this.getPresetFonts());
        }
        else {
            this.setCurentFonts(this.googleFonts);
        }
    };
    FontPickerComponent.prototype.setCurentFonts = function (target) {
        var _this = this;
        if (target != this.currentFonts) {
            this.currentFonts = target;
            this.loadedFonts = this.fontAmount;
            var initialFonts = this.currentFonts.slice(0, this.fontAmount);
            this.loadGoogleFonts(initialFonts);
            setTimeout(function () {
                _this.scrollbar.scrollTo(0);
            }, 0);
        }
    };
    FontPickerComponent.prototype.findFont = function (searchVal, exactMatch) {
        if (exactMatch === void 0) { exactMatch = false; }
        return this.findFonts(searchVal, exactMatch)[0];
    };
    FontPickerComponent.prototype.findFonts = function (searchVal, exactMatch) {
        if (exactMatch === void 0) { exactMatch = false; }
        searchVal = searchVal.toLowerCase();
        var fullmatchFonts = [];
        var candidateFonts = [];
        this.googleFonts.forEach(function (font) {
            if (searchVal === font.family.toLowerCase()) {
                fullmatchFonts.push(font);
                return;
            }
            if (exactMatch == false && font.family.toLowerCase().indexOf(searchVal) > -1) {
                candidateFonts.push(font);
            }
        });
        var resultFonts = fullmatchFonts.concat(candidateFonts);
        return resultFonts;
    };
    FontPickerComponent.prototype.loadMoreFonts = function () {
        var _this = this;
        if (this.open && !this.loading && this.loadedFonts < this.currentFonts.length) {
            var moreFonts = this.currentFonts.slice(this.loadedFonts, this.loadedFonts + this.fontAmount);
            this.loadGoogleFonts(moreFonts);
            this.loadedFonts += moreFonts.length;
            setTimeout(function () { _this.scrollbar.update(); }, 0);
        }
    };
    FontPickerComponent.prototype.loadGoogleFonts = function (fonts) {
        var _this = this;
        fonts.slice(0, this.fontAmount).forEach(function (font) {
            if (font && font.files && !_this.isFontAvailable(font)) {
                var style = font.styles.indexOf('regular') > -1 ? '' : ':' + font.styles.find(function (x) { return !isNaN(x); });
                try {
                    WebFont.load({
                        google: {
                            families: [font.family + ':' + style]
                        }
                    });
                }
                catch (e) {
                    console.warn('Problem with loading font:', font);
                }
            }
        });
    };
    FontPickerComponent.prototype.searchGoogleFonts = function (value) {
        if (!value) {
            this.onSearchReset();
            return;
        }
        value = value.toLowerCase();
        var searchResult = Array();
        if (this.googleFonts) {
            this.loadedFonts = this.fontAmount;
            searchResult = this.findFonts(value, false);
            this.setCurentFonts(searchResult);
        }
    };
    FontPickerComponent.prototype.convertGoogleFont = function (font) {
        var convertedFont = new interfaces_1.Font({
            family: font.family,
            styles: font.variants,
            files: font.files,
            style: null,
            size: null
        });
        return convertedFont;
    };
    FontPickerComponent.prototype.onResize = function () {
        if (this.position === 'fixed') {
            this.setDialogPosition();
        }
        else {
            this.closeFontPicker();
        }
    };
    FontPickerComponent.prototype.onMouseDown = function (event) {
        if (!this.isDescendant(this.el.nativeElement, event.target) &&
            event.target != this.directiveElementRef.nativeElement) {
            this.closeFontPicker();
        }
    };
    FontPickerComponent.prototype.onUploadFiles = function () {
    };
    FontPickerComponent.prototype.onCancelSelect = function () {
        this.selectedFont = false;
        this.font.family = this.initialFont.family;
        this.font.size = this.initialFont.size;
        this.font.files = this.initialFont.files;
        this.font.style = this.initialFont.style;
        this.font.styles = this.initialFont.styles;
        this.closeFontPicker();
        this.directiveInstance.fontChanged(this.font);
    };
    FontPickerComponent.prototype.onSelectFont = function (font) {
        this.selectedFont = true;
        this.font.family = font.family;
        this.font.styles = font.styles;
        this.font.files = font.files;
        this.font.style = font.styles.indexOf('regular') > -1 ? 'regular' : font.styles[0];
        this.directiveInstance.fontChanged(this.font);
    };
    FontPickerComponent.prototype.onSearchReset = function (event) {
        this.searchTerm.setValue('');
        this.setCurentFonts(this.googleFonts);
    };
    FontPickerComponent.prototype.onFontSizeChange = function (event, font) {
        this.font.size = event.target.value + 'px';
        this.directiveInstance.fontChanged(this.font);
    };
    FontPickerComponent.prototype.onFontStyleChange = function (event, font) {
        var str = this.font.family + ':' + event.target.value;
        if (font.files) {
            WebFont.load({
                google: {
                    families: [str]
                }
            });
        }
        this.directiveInstance.fontChanged(this.font);
    };
    FontPickerComponent.prototype.isDescendant = function (parent, child) {
        var node = child.parentNode;
        while (node !== null) {
            if (node === parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    };
    FontPickerComponent.prototype.createDialogBox = function (element, offset) {
        return {
            top: element.getBoundingClientRect().top + (offset ? window.pageYOffset : 0),
            left: element.getBoundingClientRect().left + (offset ? window.pageXOffset : 0),
            width: element.offsetWidth,
            height: element.offsetHeight
        };
    };
    FontPickerComponent.prototype.setDialogPosition = function () {
        var parentNode = null;
        var position = 'static';
        var node = this.directiveElementRef.nativeElement;
        var dialogHeight = this.dialogElement.nativeElement.offsetHeight;
        while (node !== null && node.tagName !== 'HTML') {
            position = window.getComputedStyle(node).getPropertyValue('position');
            if (position !== 'static' && parentNode === null) {
                parentNode = node;
            }
            if (position === 'fixed') {
                break;
            }
            node = node.parentNode;
        }
        if (position !== 'fixed') {
            var boxDirective = this.createDialogBox(this.directiveElementRef.nativeElement, true);
            if (parentNode === null) {
                parentNode = node;
            }
            var boxParent = this.createDialogBox(parentNode, true);
            this.top = boxDirective.top - boxParent.top;
            this.left = boxDirective.left - boxParent.left;
        }
        else {
            var boxDirective = this.createDialogBox(this.directiveElementRef.nativeElement, false);
            this.top = boxDirective.top;
            this.left = boxDirective.left;
            this.position = 'fixed';
        }
        if (!this.fpWidth) {
            this.fpWidth = boxDirective.width;
        }
        if (!this.fpHeight) {
            this.fpHeight = boxDirective.height;
        }
        if (this.fpPosition === 'left') {
            this.top += boxDirective.height * this.fpPositionOffset / 100 - this.dialogArrowOffset;
            this.left -= this.fpWidth + this.dialogArrowSize;
        }
        else if (this.fpPosition === 'top') {
            this.top -= dialogHeight + this.dialogArrowSize;
            this.left += this.fpPositionOffset / 100 * boxDirective.width - this.dialogArrowOffset - 1;
            this.arrowTop = dialogHeight - 1;
        }
        else if (this.fpPosition === 'bottom') {
            this.top += boxDirective.height + this.dialogArrowSize;
            this.left += this.fpPositionOffset / 100 * boxDirective.width - this.dialogArrowOffset - 1;
        }
        else {
            this.top += boxDirective.height * this.fpPositionOffset / 100 - this.dialogArrowOffset;
            this.left += boxDirective.width + this.dialogArrowSize;
        }
    };
    __decorate([
        core_1.ViewChild('dialogPopup'), 
        __metadata('design:type', Object)
    ], FontPickerComponent.prototype, "dialogElement", void 0);
    __decorate([
        core_1.ViewChild('dialogScrollbar'), 
        __metadata('design:type', (typeof (_a = typeof angular2_perfect_scrollbar_1.PerfectScrollbarComponent !== 'undefined' && angular2_perfect_scrollbar_1.PerfectScrollbarComponent) === 'function' && _a) || Object)
    ], FontPickerComponent.prototype, "scrollbar", void 0);
    FontPickerComponent = __decorate([
        core_1.Component({
            selector: 'font-picker',
            template: require('./font-picker.component.html'),
            styles: [require('./font-picker.component.scss')]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _b) || Object, (typeof (_c = typeof font_picker_service_1.FontPickerService !== 'undefined' && font_picker_service_1.FontPickerService) === 'function' && _c) || Object])
    ], FontPickerComponent);
    return FontPickerComponent;
    var _a, _b, _c;
}());
exports.FontPickerComponent = FontPickerComponent;



//////////////////
// WEBPACK FOOTER
// ./src/lib/font-picker.component.ts
// module id = 12
// module chunks = 0 1